import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';

interface State {
  impersonating: boolean;
  admin_id?: string | null;
  reason?: string | null;
  expires_at?: string;
}

export function ImpersonateBanner() {
  const [state, setState] = useState<State | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function check() {
      try {
        const data = await api<State>('/session/impersonating');
        if (!cancelled) setState(data);
      } catch {
        if (!cancelled) setState({ impersonating: false });
      }
    }
    void check();
    const interval = window.setInterval(check, 30_000);
    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, []);

  if (!state?.impersonating) return null;

  async function endNow() {
    await api('/session/end-impersonate', { method: 'POST' });
    window.location.href = '/login';
  }

  const remainingMin =
    state.expires_at
      ? Math.max(0, Math.round((new Date(state.expires_at).getTime() - Date.now()) / 60_000))
      : null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-rose-600 text-white px-4 py-2 flex items-center justify-between gap-3 text-sm">
      <div>
        <strong>IMPERSONATE ATIVO</strong> · razão: {state.reason ?? '—'}
        {remainingMin !== null && <span className="ml-3 opacity-80">expira em ~{remainingMin}min</span>}
      </div>
      <button
        onClick={endNow}
        className="rounded bg-rose-900 hover:bg-rose-800 px-3 py-1 text-xs font-medium"
      >
        Encerrar e voltar ao login
      </button>
    </div>
  );
}
